exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-layer{z-index:11;text-align:left}.logo-layer .logo-wrap{position:absolute;top:15px;right:15px;opacity:.7;text-align:right}.logo-layer .logo-wrap img{max-width:160px;height:48px}", ""]);

// exports
